import { render, staticRenderFns } from "./ClientAddressFieldLookup.vue?vue&type=template&id=923a56ba&scoped=true"
import script from "./ClientAddressFieldLookup.vue?vue&type=script&lang=js"
export * from "./ClientAddressFieldLookup.vue?vue&type=script&lang=js"
import style0 from "./ClientAddressFieldLookup.vue?vue&type=style&index=0&id=923a56ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923a56ba",
  null
  
)

export default component.exports